module.exports = "<p>\n  not-found works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /mnt/disk/stratbox.dev/src/app/not-found/not-found.component.html
// module id = ../../../../../src/app/not-found/not-found.component.html
// module chunks = main